
import api from "@/api";
import { Operator } from "@/api/dtos/Operator.schema";
import { Component, Prop, Vue } from "vue-property-decorator";
import DangerButton from "../buttons/DangerButton.vue";
import DangerDialog from "../dialogs/DangerDialog.vue";
import EditFrame from "../EditFrame.vue";
import { showToast } from "@/utils/toastService";
import { getAxiosResponse } from "@/utils/errorUtils";
@Component({
  components: {
    EditFrame,
    DangerButton,
    DangerDialog
  },
})
export default class BlockAndDeleteOperator extends Vue {
  @Prop()
  operator!: Operator;

  showDeleteDialog = false;
  showBlockDialog = false;

  isOperatorActive = false;

  mounted(): void {
    this.isOperatorActive = this.operator.isActive;
    console.log(this.isOperatorActive);
  }

  async onConfirmBlockOperator(): Promise<void> {
    try {
      await api.OperatorsApi.updateIsOperatorActive(
        this.operator.uuid,
        !this.isOperatorActive
      );

      const message = this.isOperatorActive
        ? "Betreiber erfolgreich gesperrt"
        : "Betreiber erfolgreich entsperrt";

      showToast({
        message: message,
        type: "success",
      });

      this.isOperatorActive = !this.isOperatorActive;
    } catch (e) {
      showToast({
        response: getAxiosResponse(e),
        message: "Fehler beim Ändern des Status des Betreibers",
        type: "error",
      });
      console.error("Error updating operator status:", e);
    }
  }

  async onConfirmDeleteOperator(): Promise<void> {
    try {
      await api.OperatorsApi.deleteOperator(this.operator.uuid);

      showToast({
        message: "Betreiber erfolgreich gelöscht",
        type: "success",
      });

      this.$router.push({ name: "Stationen" });
    } catch (e) {
      showToast({
        response: getAxiosResponse(e),
        message: "Fehler beim Löschen des Betreibers",
        type: "error",
      });
      console.error("Error deleting operator:", e);
    }
  }
}
